/* eslint-disable react/jsx-props-no-spreading */
import { Editable } from '@niche-js/core/components';
import classNames from 'classnames';
import { ElementType, ReactNode } from 'react';

import styles from '../../styles/typography/typography.module.css';

export interface TypographyProps {
    tag?: ElementType;
    children?: ReactNode;
    html?: string | null;
    editable?: string | null;
    editablePicker?: string | null;
    editableInline?: boolean;
    placeholder?: boolean;
    placeholderLines?: number;
    className?: string | null;
    // autres props HTML autorisées
    [prop: string]: unknown;
}

function Typography({
    tag: Component = 'div',
    children = null,
    html = null,
    editable = null,
    editablePicker = null, // non supporté par Editable, utilisé seulement pour React.createElement
    editableInline = true,
    placeholder = false,
    className = null,
    ...props
}: TypographyProps) {
    const isEditable = editable !== null;
    const classNameValue = classNames([
        className,
        {
            [styles.placeholder]: placeholder,
        },
    ]);
    // Editable attend un tag string uniquement
    if (isEditable) {
        return (
            <Editable
                tag={Component}
                name={editable}
                className={classNameValue}
                html={html}
                inline={editableInline}
                picker={editablePicker} // Editable ne supporte pas le picker, mais on le garde pour la compatibilité
                {...props}
            >
                {children}
            </Editable>
        );
    }
    return (
        <Component
            className={classNames([
                className,
                {
                    [styles.placeholder]: placeholder,
                },
            ])}
            dangerouslySetInnerHTML={html !== null && !placeholder ? { __html: html } : null}
            {...props}
        >
            {children}
            {/* {placeholder ? getPlaceholderText(placeholderLines) : children} */}
        </Component>
    );
}

export default Typography;
